import type { EuiGlobalToastListToast } from "@elastic/eui";

import { FormDataType } from "../../components/FormDataTypes";
import type { FormType } from "../../types/Rater.types";

type FormWithIndex = {
  form: Pick<FormType, "name">;
  index: number;
};

type Args = {
  formsToRemove: FormWithIndex[];
  formsData: Record<string, FormDataType>;
  addToast: (toast: Omit<EuiGlobalToastListToast, "id">) => void;
  removeForm: (index: number) => void;
  reason: string;
  toast?: {
    title?: string;
    color?: EuiGlobalToastListToast["color"];
    text?: string;
  };
};

export function removeFormsWithToast({ addToast, removeForm, formsData, formsToRemove, reason, toast }: Args) {
  if (formsToRemove.length === 0) return;

  const sortedFormsToRemove = [...formsToRemove].sort((a, b) => b.index - a.index);

  const removeLabels = sortedFormsToRemove.map(({ form }) => {
    const formData = formsData[form.name];
    return formData?.displayFormName ?? formData?.formTitle ?? form.name;
  });

  addToast({
    title: toast?.title ?? `${formsToRemove.length} ${formsToRemove.length === 1 ? "form" : "forms"} removed`,
    color: toast?.color ?? "danger",
    text:
      toast?.text ??
      `${removeLabels.join(", ")} ${formsToRemove.length === 1 ? "has" : "have"} been removed ${reason}.`,
  });

  sortedFormsToRemove.forEach(({ index }) => {
    removeForm(index);
  });
}
